export default "__VITE_ASSET__CYYw4aOJ__"